// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__1eUd1","info":"Note_info__1JLJp","note":"Note_note__AnEg6","actions":"Note_actions__3Z2R9"};